import { render, staticRenderFns } from "./TabelaMunicipiosIBGE.vue?vue&type=template&id=78a02643"
import script from "./TabelaMunicipiosIBGE.vue?vue&type=script&lang=js"
export * from "./TabelaMunicipiosIBGE.vue?vue&type=script&lang=js"
import style0 from "./TabelaMunicipiosIBGE.vue?vue&type=style&index=0&id=78a02643&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports